<template>
  <div>
    <div class="option" :style="{color: iconColor}" @click.stop="onClickAdd()" :key="itemId" v-if="!isFav">
      <icon-svg icon-class="shezhiye_jiarushujia"></icon-svg>
    </div>
    <div class="option" :style="{color: iconColor}" @click.stop="onClickRemove()" :key="itemId" v-else>
      <icon-svg icon-class="done"></icon-svg>
    </div>
  </div>
</template>

<script>
  import {Toast} from "vant"
  export default {
    name: "BookShelfAction",
    props: {
      item: {},
      color: {},
    },

    data() {
      return {
        itemId: 0,
        isFav: false,
        listTypeBookShelf: "book_shelf",
        iconColor: "rgba(64,62,64,0.72)",
      }
    },

    mounted() {
      this.isFav = this.checkInShelf()
      this.itemId = this.item.id
      if (this.color) {
        this.iconColor = this.color
      }
    },

    methods: {
      checkInShelf() {
        if (!this.item || !this.item.id) {
          return false
        } else if (!this.item.item_list) {
          return false
        } else if (!this.item.item_list.book_shelf) {
          return false
        } else {
          return true
        }
      },

      onClickAdd() {
        let params = {
          item_id: this.itemId,
          action: "add",
          list_type: this.listTypeBookShelf,
        }
        this.$store.dispatch("UpdateItemList", params).then((data) => {
          if (data.code === 0) {
            this.isFav = true
            Toast("加入书架")
          } else if (data.code === 20010) {
            Toast("请先登录")
          } else {
            Toast("系统错误")
          }
        }, () => {
          Toast("网络错误")
        })
      },

      onClickRemove() {
        this.isFav = false
        let params = {
          item_id: this.itemId,
          action: "remove",
          list_type: this.listTypeBookShelf,
        }
        this.$store.dispatch("UpdateItemList", params).then((data) => {
          if (data.code === 0) {
            Toast("移出书架")
          } else {
            Toast("系统错误")
          }
        }, () => {
          Toast("网络错误")
        })
      },
    },
    watch: {
      item() {
        this.isFav = this.checkInShelf()
        this.itemId = this.item.id
      }
    }

  }

</script>

<style lang="scss" scoped>

  .option {
    color: rgba(180, 9, 13, 0.82);
    font-size: 16px;
  }

</style>
